<template lang="pug">
  div.modal
    div.content
      section.block
        div.blc
          h2 最低限必要な横幅について
          p.txt FKレールの取付け位置は。壁際より7.5mm以上のすき間を<br>
            | 確保してください。<br>
            | 取付け面の幅に対してFKレール寸法に左右7.5mmずつを加えた寸法が<br>
            | 取付けに必要な幅となります。
        figure.w250
          img(:src="base + 'static/img/img_help_width.png'")
      section.block
        div.blc
          h2 最低限必要な高さについて
          p.txt FKスリットの取付け位置は、天井より50mm以上、床より100mm以上の<br>すき間を確保してください。<br>
            | 取付け面の高さに対して、FKスリット寸法に上部50mm、下部100mm、<br>計150mmを加えた寸法が取付けに必要な高さになります。<br>
          div.notes
            dl
              dt 注意
              dd 柱・梁・点検口等のある上には取付けできません。
            div.img
              img(:src="base + 'static/img/img_help_height01.png'")
        figure
          img(:src="base + 'static/img/img_help_height.png'")
      section.block
        div.blc
          h2 最低限必要な奥行について
          p.txt 木棚は幅4種類×奥行4種類＝16種類が基本サイズです。<br>
            | 各木棚の奥行き寸法に、<strong>FKスリットの奥行寸法17mmを加えた寸法</strong>で
            | 設定してください。（例：D600＋17mm＝617mm）※1
          div.notes
            dl
              dt 注意
              dd 収納内部等、下がり壁のある場合（ドアの高さが天井までない場合）は、<br>
                | 木棚の奥行き寸法によっては収納物の出入れができなくなります。ご注意ください。※2
          div.notes
            dl
              dt 注意
              dd ウォークインクローゼットなど、L型・U型の割付けする場合棚と棚が取合う場所は、<br><strong>15mm以上のすき間</strong>を確保してください。<br>また、木棚（ブラケット）は、手前に向かって１度上がっているため、Ｌ型・Ｕ型で隣に並んだ際は、<strong>平行にはなりません</strong>。ご注意ください。
          div.img
            img(:src="base + 'static/img/img_help_depth02.png'",width="400")
        figure.w250
          strong ■木棚の種類<br>
          img(:src="base + 'static/img/img_help_depth01.png'")
          img(:src="base + 'static/img/img_help_depth.png'")
      section.block
        div.blc
          h2 FKスリットの長さ別下地推奨位置
          p.txt
            | 部分的に下地を入れる場合は、下図を参考に下地位置・範囲を決めてください。<br>
            | 図中のグレー部分が推奨する下地範囲となります。図中 部分は、必ず下地を入れてください。<br>
            | 下地がない場合は石膏ボード用アンカーを使用すれば設置が可能です。
          ul.shitaji
            li
              div
                p
                  | ＜FKスリット H1979＞
                img(:src="base + 'static/img/img_help_stg01.jpg'")
            li
              div
                p
                  | ＜FKスリット H1753＞
                img(:src="base + 'static/img/img_help_stg02.jpg'")
            li
              div
                p
                  | ＜FKスリット H1202＞
                img(:src="base + 'static/img/img_help_stg03.jpg'")
            li
              div
                p
                  | ＜FKスリット H700＞
                img(:src="base + 'static/img/img_help_stg04.jpg'")
          div.notes
            dl
              dt 施工上の注意事項
              dd
                ul.notes-list
                  li 現地での製品加工はできません。分解したり、修理・改造は行わないでください。
                  li 棚受のねじを締め付ける際は、必ず<strong>手回しドライバーを使用</strong>してください。電動ドライバー等で締めすぎると、棚板および棚板の鬼目ナットが破損し、棚板が脱落します。
                  li 耐火建築の場合は、FKレールおよびFKスリットの取付けは同梱のねじ(M4×50mm)ではなく<strong>M4×90mm</strong>をご用意ください。
</template>

<script>
import router from '../../router';
export default{
  name: 'ModalHelp',
  data () {
    return {
      base: ''
    };
  },
  props: {
  },
  methods: {
  },
  created () {
  },
  mounted () {
    document.querySelector('body').appendChild(this.$el.parentNode.parentNode);
    this.base = router.options.base;
  }
};
</script>

<style lang="stylus" scoped>
  .modal
    h2
      margin 0
      padding 0 30px 0 0
      font-size 20px
    .content
      overflow auto
      padding 0
      position absolute
      left 0
      right 0
      top 50px
      bottom 10px
    .block
      display flex
      padding 0 30px
      margin-bottom 20px
      div.blc
        flex 1
      .txt
        font-size 14px
        padding-top 30px
    figure
      width 300px
      &.w250
        width 250px
      img
        width 100%
  .notes
    display flex
    font-size 14px
    dl
      margin-bottom 20px
      dt
        padding 5px 10px
        background-color #f5ba19
        border-radius 16px
        display inline-block
    .img
      width 150px
      img
        width 100%
  .shitaji
    display flex
    flex-wrap wrap
    justify-content space-between
    align-items self-end
    margin-bottom 20px
    li
      width 49%
      font-size 14px
      margin-bottom 30px
      img
        width 100%
  strong
    color #2e7c80
  .notes-list
    margin-top 15px
    li
      padding-left 25px
      position relative
      margin-bottom 5px
      &:before
        content "※"
        position absolute
        left 0
        top 0
</style>



// WEBPACK FOOTER //
// src/components/parts/ModalHelp.vue